<template>
  <div id="app">
    <loader
      v-if="isLoading"
      object="#5A02B8"
      color1="#000"
      color2="#5A02B8"
      size="10"
      speed="2"
      bg="#000"
      objectbg="#fff"
      opacity="80"
      disableScrolling="true"
      name="spinning"
    ></loader>
    <div class="toasts-container">
      <div v-for="(toast, indexToast) in allToasts" :key="indexToast">
        <ToastComponent :type="toast.type" :message="toast.message" :position="toast.position" :index="indexToast" />
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ToastComponent from '@/components/main-layout/toast/Toast.vue';
export default {
  components: { ToastComponent },
  computed: {
    ...mapGetters('main', ['allToasts', 'toastOptions']),
    ...mapGetters('user', ['userInfo', 'isAuth'])
  },
  data() {
    return {
      isLoading: true
    };
  },
  watch: {
    isAuth: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadChatWidget();
        } else {
          this.removeChatWidget();
        }
      }
    }
  },
  mounted() {
    document.onreadystatechange = () => {
      this.isLoading = document.readyState === 'complete' ? false : true;
    };
  },
  methods: {
    initEmbeddedMessaging() {
      if (typeof embeddedservice_bootstrap === 'undefined') {
        console.warn('⚠️ embeddedservice_bootstrap not ready');
        return;
      }
      try {
        // eslint-disable-next-line no-undef
        embeddedservice_bootstrap.settings.language = 'en_US';

        window.addEventListener('onEmbeddedMessagingReady', () => {
          console.log('✅ Received the onEmbeddedMessagingReady event…');
          // eslint-disable-next-line no-undef
          embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
            contactId: this.userInfo?.Id || ''
          });
        });
        // eslint-disable-next-line no-undef
        embeddedservice_bootstrap.init(
          '00D1H000000Muj7',
          'Agentforce',
          'https://fundamentalcapital.my.site.com/ESWAgentforce1762284039055',
          {
            scrt2URL: 'https://fundamentalcapital.my.salesforce-scrt.com'
          }
        );
      } catch (err) {
        console.error('❌ Error loading Embedded Messaging: ', err);
      }
    },

    loadChatWidget() {
      console.log('Load Salesforce Chat Widget');
      if (document.getElementById('salesforce-chat-script')) {
        this.initEmbeddedMessaging();
        return;
      }

      const script = document.createElement('script');
      script.id = 'salesforce-chat-script';
      script.src = 'https://fundamentalcapital.my.site.com/ESWAgentforce1762284039055/assets/js/bootstrap.min.js';
      script.onload = () => {
        console.log('✅ Salesforce script loaded');
        this.initEmbeddedMessaging();
      };
      document.body.appendChild(script);
    },

    removeChatWidget() {
      console.log('🧹 Remove Salesforce Chat Widget');
      const script = document.getElementById('salesforce-chat-script');
      if (script) {
        script.remove();
      }

      const container = document.getElementById('embedded-messaging');
      if (container) {
        container.innerHTML = '';
      }

      if (window.embeddedservice_bootstrap) {
        delete window.embeddedservice_bootstrap;
      }
    }
  }
};
</script>
<style lang="scss">
.toasts-container {
  position: absolute;
  z-index: 99999;
  left: 0 !important;
  right: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  width: fit-content;
}
</style>
